import React from 'react';
import ExpandedComponent from "../../microComponents/tablePages/ExpandedComponent";

const ExpandedOrder = ({item}) => {
    return (
        <ExpandedComponent items={[
            {title: 'شماره بچ\t', value: item.printBy,class:'xs:hidden'},
            {title: 'محصول', value: 'item.printBy',class:'sm:hidden'},
            {title: 'چاپ شده\t', value: item.numberOfDestroyed,class:'sm:hidden'},
            {title: 'تحویل به انبار\t', value: 'item.printBy',class:'md:hidden'},
            {title: 'ابطال', value: 'item.printBy',class:'2md:hidden'},
            {title: 'در حال بررسی\t', value: 'item.printBy',class:'lg:hidden'},
            {title: 'امحا', value: 'item.printBy',class:'lg:hidden'},
            {title: 'بازسازی شده', value: item.description,class:'lg:hidden'},
            {title: 'تعداد در پالت\t', value: item.description,class:'lg:hidden'},
            {title: 'کنترل کیفی\t', value: item.description,class:'lg:hidden'},
            {title: 'تاریخ ثبت\t', value: item.description,class:'lg:hidden'},
            {title: 'زمان پایان\t', value: item.description,class:'lg:hidden'},


        ]}/>
    );
};

export default ExpandedOrder;